import { ADD_SENIOR_FAIL, ADD_SENIOR_REQUEST, ADD_SENIOR_SUCCESS, Senior } from "../types";

export const addSeniorRequest = (senior: Senior, history: any) => {
    return {
        type: ADD_SENIOR_REQUEST,
        payload: { senior, history },
    };
};

export const addSeniorSuccess = () => {
    return {
        type: ADD_SENIOR_SUCCESS,
        // payload: senior,
    };
};

export const addSeniorFail = (error: any) => {
    return {
        type: ADD_SENIOR_FAIL,
        payload: {
            error,
        },
    };
};
